import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

const SMSIcon = (props: any) => {
    return (
        <Svg
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <G clipPath="url(#clip0_1398_2494)">
                <Path
                    d="M4.2 13.8h.6v-.6h-.6v.6zm0 3.6h-.6a.6.6 0 00.96.48l-.36-.48zM9 13.8v-.6h-.2l-.16.12.36.48zm-3.6-9h-.6V6h.6V4.8zM12.6 6h.6V4.8h-.6V6zM5.4 8.4h-.6v1.2h.6V8.4zm4.8 1.2h.6V8.4h-.6v1.2zm-6.6 4.2v3.6h1.2v-3.6H3.6zm.96 4.08l4.8-3.6-.72-.96-4.8 3.6.72.96zM9 14.4h7.2v-1.2H9v1.2zm7.2 0a1.8 1.8 0 001.8-1.8h-1.2c0 .331-.267.6-.6.6v1.2zm1.8-1.8V1.8h-1.2v10.8H18zm0-10.8c0-.995-.805-1.8-1.8-1.8v1.2c.333 0 .6.269.6.6H18zM16.2 0H1.8v1.2h14.4V0zM1.8 0C.805 0 0 .805 0 1.8h1.2c0-.331.267-.6.6-.6V0zM0 1.8v10.8h1.2V1.8H0zm0 10.8a1.8 1.8 0 001.8 1.8v-1.2a.599.599 0 01-.6-.6H0zm1.8 1.8h2.4v-1.2H1.8v1.2zM5.4 6h7.2V4.8H5.4V6zm0 3.6h4.8V8.4H5.4v1.2z"
                    fill={props.color}
                />
            </G>
            <Defs>
                <ClipPath id="clip0_1398_2494">
                    <Path fill="#fff" d="M0 0H18V18H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SMSIcon
